import { AppPath, DashboardPath } from 'appConstants';
import { FooterLinks } from 'components/footer/types';
import { SideMenuLink } from 'components/sideMenu/SideMenu';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Icons, clearIcon, selectAccountTypePathItem } from 'reducers/componentResources';
import chevron from '../../assets/ibanera/Icon_Dropdown_01.png';
import { MobileNavigationButton, StaticIcon } from './MobileNavigationButton';

//icons
import VisaIcon from 'assets/ibanera/Icon_Card_01.png';
import MCIcon from 'assets/ibanera/Icon_Card_02.png';
import { InfoRequestNavLink } from '../../pages/InfoRequest/InfoRequestNavLink';
import { TextCurrencyIcon } from 'components/currencyIcon/CurrencyIcon';
import { BulkTransferSideNavLink } from '../../pages/account/BulkTransfer/BulkTransferSideNavLink';
import { useTranslation } from 'react-i18next';
import { FooterLikItem } from 'components/footer/types';

enum SubPage {
    ACCOUNTS = 'Accounts',
    CARDS = 'Cards',
    CRYPTO = 'Crypto',
    MORE = 'More',
}

type SignedInMoreMenuProps = {
    linksFromFooter: FooterLinks | null;
    pageLinks: SideMenuLink[] | null;
    pageLinkIcons: Icons | null;
    navigateWithCultureCode: (path: string) => void;
    closeMenu: () => void;
    setCurrentSubPage: React.Dispatch<React.SetStateAction<SubPage | null>> | null;
};

export const SignedInMoreMenu: React.FC<SignedInMoreMenuProps> = ({
    linksFromFooter,
    pageLinks,
    pageLinkIcons,
    navigateWithCultureCode,
    closeMenu,
    setCurrentSubPage
}) => {
    const accountTypePathItem = useSelector(selectAccountTypePathItem);
    const dispatch = useDispatch();
    const { t, i18n } = useTranslation('common');

    return (
        <div className="MoreMenu">
            <div className="PageLinks">
                <InfoRequestNavLink mobile onLinkPressed={closeMenu} />
                <BulkTransferSideNavLink mobileMenu setCurrentSubPage={setCurrentSubPage} />

                {pageLinks &&
                    pageLinkIcons &&
                    pageLinks.map((link, index) => {
                        const linkHasChildren = !!link.childElements;
                        return (
                            <div
                                onClick={() =>
                                    navigateWithCultureCode(`${accountTypePathItem}/${link.path}`)
                                }
                                key={link.id}
                                className="MoreMenuPageLink"
                            >
                                {pageLinkIcons[link.iconName].mobileInactive ? (
                                    <img
                                        src={
                                            link.iconName
                                                ? pageLinkIcons[link.iconName].mobileInactive ?? ''
                                                : ''
                                        }
                                        alt="Icon"
                                        className="Icon"
                                        onError={() => {
                                            dispatch(clearIcon(link.iconName));
                                        }}
                                    />
                                ) : (
                                    <TextCurrencyIcon currencySymbol={link.displayName[0]} />
                                )}
                                <span className="LinkLabel">
                                    {link.displayName}
                                    {link.elementType === 'QuickCoin' && (
                                        <div className="CardIcons">
                                            {[VisaIcon, MCIcon].map((icon) => (
                                                <img src={icon} alt="" />
                                            ))}
                                        </div>
                                    )}
                                </span>
                                {<img src={chevron} alt="chevron" className="Chevron" />}
                            </div>
                        );
                    })}
            </div>
            <div className="FooterLinks">
                {linksFromFooter &&
                    linksFromFooter.map((link) => {
                        const footerKey = `footer_${link.title}`;
                        const hasTranslation = i18n.exists(footerKey);
                        const title = hasTranslation ? t(footerKey) : link.title;
                        return (
                            <div
                                key={link.id}
                                onClick={() =>
                                    navigateWithCultureCode(
                                        `${accountTypePathItem}${DashboardPath.INFO}${link.url}`
                                    )
                                }
                                className={`FooterLink${hasTranslation ? ' notranslate' : ''}`}
                                translate={hasTranslation ? 'no' : undefined}
                            >
                                {title}
                            </div>
                        );
                    })}
            </div>
        </div>
    );
};

type PublicMoreMenuProps = {
    linksFromFooter: FooterLinks | null;
    navigateWithCultureCode: (path: string) => void;
};

export const PublicMoreMenu: React.FC<PublicMoreMenuProps> = ({
    linksFromFooter,
    navigateWithCultureCode,
}) => {
    const { t, i18n } = useTranslation('common');
    const { t: tAuth } = useTranslation('auth');
    return (
        <div className="MoreMenu">
            <div className="PageLinks">
                <MobileNavigationButton
                    onClick={() => navigateWithCultureCode(`${AppPath.SIGN_IN}`)}
                    label={tAuth('signIn')}
                    icon={StaticIcon.SIGN_IN}
                    className="MoreMenuPageLink notranslate"
                    isActive={false}
                />
                <MobileNavigationButton
                    onClick={() => navigateWithCultureCode(`${AppPath.REGISTER}`)}
                    label={tAuth('register')}
                    icon={StaticIcon.REGISTER}
                    className="MoreMenuPageLink notranslate"
                    isActive={false}
                />
            </div>
            <div className="FooterLinks">
                {linksFromFooter &&
                    linksFromFooter.map((link) => {
                        const footerKey = `footer_${link.title}`;
                        const hasTranslation = i18n.exists(footerKey);
                        const title = hasTranslation ? t(footerKey) : link.title;
                        return (
                            <div
                                key={link.id}
                                onClick={() =>
                                    navigateWithCultureCode(`${AppPath.INFO}${link.url}`)
                                }
                                className={`FooterLink${hasTranslation ? ' notranslate' : ''}`}
                                translate={hasTranslation ? 'no' : undefined}
                            >
                                {title}
                            </div>
                        );
                    })}
            </div>
        </div>
    );
};
